// extracted by mini-css-extract-plugin
export default {"transitionTime":"50ms","button":"B4jok5","iconClear":"WLZbq7","buttonEnter":"iSSqLp","buttonLeave":"_X_v4j","buttonEnterDone":"MCVLlO","buttonLeaveActive":"U_rPtT"};